import { ProvisionalOptionContractMutation } from "@/generated/graphql_billing";
import { graphql, HttpResponse } from "msw";

// 契約を行う
export const provisionalOptionContractMutationHandler =
  graphql.mutation<ProvisionalOptionContractMutation>(
    "provisionalOptionContract",
    ({ query, variables }) => {
      return HttpResponse.json({
        data: {
          provisionalOptionContract: {
            result: true,
          },
        },
      });
    }
  );
